// extracted by mini-css-extract-plugin
export var pillWrapper = "_pw-0";
export var showOverflow = "_pw-1";